import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Counter } from 'src/app/api/api-campaigns.service.generated';

@Component({
  selector: 'app-counter-strategy-edit',
  templateUrl: './counter-strategy-edit.component.html',
  styleUrls: ['./counter-strategy-edit.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule
  ]
})
export class CounterStrategyEditComponent implements OnInit {

  @Input() strategy: Counter;

  Array = Array;
  parseInt = parseInt;

  constructor() { }

  ngOnInit() { }

}
